import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { BuildPriceEntities } from 'client/data/models/build-price';
import { INVENTORY_TYPES_LOWERCASE } from 'client/constants/inventory-types';
import { srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';
import { buildNextLink } from 'site-modules/shared/utils/build-price/build-price';

export function GetQuotesLink({
  location,
  className = null,
  buildPriceFilter,
  leadFormDealerCount = null,
  makeModelInventoryCount = null,
  makeSlug,
  modelSlug,
}) {
  const { pathname } = location;

  if (!leadFormDealerCount && !makeModelInventoryCount) {
    return null;
  }

  return (
    <Button
      tag="a"
      href={
        leadFormDealerCount
          ? `${buildNextLink(buildPriceFilter, {}, pathname)}&getQuotes`
          : srpLinkBuilder({
              make: makeSlug,
              model: modelSlug,
              radius: 200,
              inventorytype: INVENTORY_TYPES_LOWERCASE.NEW,
            })
      }
      color="primary-b"
      size="lg"
      className={classnames(
        'get-quotes-link d-flex justify-content-center align-items-center px-1 py-1 py-md-0_5',
        className
      )}
    >
      {leadFormDealerCount ? 'Get dealer quotes' : 'See all for sale'}{' '}
      <i className="d-inline-block icon-arrow-right4 ms-0_5" aria-hidden />
    </Button>
  );
}

GetQuotesLink.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  makeSlug: PropTypes.string.isRequired,
  modelSlug: PropTypes.string.isRequired,
  buildPriceFilter: BuildPriceEntities.BuildPriceFilter.isRequired,
  leadFormDealerCount: PropTypes.number,
  makeModelInventoryCount: PropTypes.number,
  className: PropTypes.string,
};
